import { render, staticRenderFns } from "./PostsFeed.vue?vue&type=template&id=74bfed42&"
import script from "./PostsFeed.vue?vue&type=script&lang=js&"
export * from "./PostsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports